import { Application } from '../application';

var ProfileNagEdit = (function($) {
  function make_form_editable(_event) {
    $('.section-edit-button').trigger('click');
    $('#control-buttons').hide();
    $('#save-and-continue-profile-verification').show();
    $('#profile-verification-cancel').show();
  }
  function setup_edit_all_button() {
    $('#profile-verification-edit').on('click', make_form_editable);
  }
  function hide_edit_buttons() {
    $('.section-edit-button').hide();
  }

  function hasOnlyCertificationError() {
    return !$('#profile-nag-errors').data('has-errors');
  }

  function showFlashErrors() {
    var el = document.getElementById('profile-nag-errors');
    if (el && el.getAttribute('data-error-messages')) {
      Flash.error(el.getAttribute('data-error-messages'));
      $('#alert-error .flash-right').blur();
    }
  }

  function setup() {
    $(function () {
      if (Application.current({
        controller: 'user_profile_verifications'
      })) {
        hide_edit_buttons();
        setup_edit_all_button();
        showFlashErrors();
      }
      if (Application.current({
        controller: 'user_profile_verifications',
        action: 'update'
      })) {
        if (!hasOnlyCertificationError()) {
          $('#profile-verification-edit').trigger('click');
          make_form_editable();
        }
      }
    });
  }
  return {
    setup: setup
  };
}(jQuery));

ProfileNagEdit.setup();
